import { uniqBy } from 'lodash-es';
import { supportedCountries } from '@xarvio/frontend-core-platform/lib/country/CountryUtils';

export const hasMultipleLanguages = (countryCode: string) => {
  const entries = supportedCountries.filter(
    (country) => country.countryCode === countryCode,
  );

  return (
    uniqBy(entries, (entry: { languageCode: string }) => entry.languageCode)
      ?.length > 1
  );
};
